export default __webpack_public_path__ + "static/media/jharris.b00f7dfd.png";